import { useEffect } from "react";
import api from "@/lib/api";
import { captureSignupSource } from "@/lib/signupSource";

const KEY = "armstrong_ref_code";

/**
 * Mounts at app root. On every page load, captures `?ref=<code>` from
 * the URL into localStorage AND fires-and-forgets a backend visit log.
 * The captured code is read by checkout flows (Buy Now button etc).
 */
export default function ReferralCapture() {
  useEffect(() => {
    captureSignupSource();
    try {
      const url = new URL(window.location.href);
      const code = (url.searchParams.get("ref") || "").trim().toLowerCase();
      if (!code) return;
      localStorage.setItem(KEY, code);
      api.post("/referrals/track", { code }).catch(() => {});
    } catch {/* ignore */}
  }, []);
  return null;
}

export function getReferralCode() {
  try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
}
